/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MinusIcon20Regular = forwardRef('MinusIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.25 10A.75.75 0 0 1 3 9.25h14a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z" })));
});
